module.exports = __webpack_public_path__ + "static/media/Añadir_titulo_on.094b0278.png";